import { makeStyles } from '@material-ui/core';
import { baseColors } from '@ncr-retail/mui-theme';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../mui-theme';

const baseColor = baseColors();

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  rejectButton: {
    marginRight: '1.7vw',
    border: `1px solid ${themeColor.secondaryLight}`,
    color: themeColor.defaultTextColor,
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: '24px',
  },
  acceptButton: {
    background: _theme.palette.primary.main,
    color: 'white',
    marginBottom: '3.58vh',
    marginRight: 12,
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: '24px',
    boxShadow: `0 1px 1px 0 ${themeColor.semitransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  container: {
    marginLeft: '5%',
    justifyContent: 'center',
  },
  title: {
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    fontSize: rem(2),
    marginBlockStart: '0',
    marginBlockEnd: '.5em',
    padding: '0 5%',
    letterSpacing: '0.2px',
    color: themeColor.defaultTextColor,
  },
  message: {
    paddingTop: '1.5em',
    lineHeight: '1.56',
    color: themeColor.blackish,
    fontSize: rem(1.125),
    marginBlockStart: 0,
    marginBlockEnd: 0,
    fontWeight: 500,
    width: '100%',
    paddingLeft: '5%',
    paddingRight: '5%',
    whiteSpace: 'pre-wrap',
  },
  subBarText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: rem(1.125),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.5px',
    color: baseColor.palesky,
    marginTop: '-.5em',
  },
  contentItemNameSubText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: rem(1.25),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.5px',
    color: baseColor.tangaroa,
    paddingBottom: '10px',
  },
  contentItemCodeSubText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: rem(1),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.5px',
    color: baseColor.palesky,
    paddingBottom: '10px',
  },
  currencyText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: rem(1.25),
    lineHeight: '23px',
    alignItems: 'center',
    textAlign: 'right',
    letterSpacing: '0.0025em',
    color: themeColor.defaultTextColor,
  },
}));
